import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
const axios = require('axios')

export default {
  getFolder: function ({parentId}) {
    const query = parentId ? `?parentFolder=${parentId}` : ''
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.get('folders' + query)
  },
  createFolder: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('folders', template)
  },
  deleteFolder: function (id) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.delete('folders/' + id)
  },
  updateFolder: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.put('folders/' + template.id, template)
  },
  updatePosition: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('folders/updateposition', template)
  },
  updateParent: function (template) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token')
      }
    })
    return instCred.post('folders/updateparent', template)
  }
}



// WEBPACK FOOTER //
// ./src/api/Folders/api.js